import {createBrowserRouter, RouterProvider} from "react-router-dom";
import React from "react";
import {Root} from "../layout/Root";
import {NotFound} from "./NotFound";
import {AuthenticationRequiredWrapper} from "./AuthenticationRequiredWrapper";
import {BusinessesPage} from "../pages/business/BusinessesPage";
import LogoutPage from "../pages/LogoutPage";
import {NewOrderPage} from "../pages/newOrder/NewOrderPage";
import {NewOrderBusinessInfo} from "../pages/newOrder/NewOrderBusinessInfo";
import {NewOrderProduct} from "../pages/newOrder/NewOrderProduct";
import {NewOrderAddons} from "../pages/newOrder/NewOrderAddons";
import {NewOrderPayment} from "../pages/newOrder/NewOrderPayment";
import {UsersPage} from "../pages/users/UsersPage";
import {UsersGrid} from "../pages/users/UsersGrid";
import {NewUser} from "../pages/users/NewUser";
import {BusinessPage} from "../pages/business/BusinessPage";
import {BusinessSummary} from "../pages/business/BusinessSummary";
import {ProductsPage} from "../pages/product/ProductsPage";
import {InventoryManagement} from "../pages/product/InventoryManagement";
import {RemotePurchase} from "../pages/public/RemotePurchase";
import {SalesReportPage} from "../pages/sales/SalesReportPage";
import {GrowthCoachSummary} from "../pages/sales/GrowthCoachSummary";
import {AccountingPage} from "../pages/accounting/AccountingPage";
import {AccountingTabs} from "../pages/accounting/AccountingTabs";
import {AudiencesPage} from "../pages/tools/AudiencesPage";

export const DsRoutes: React.FC = () => {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <Root/>,
            errorElement: <NotFound/>,
            children: [
                {
                    path: "/",
                    element: <AuthenticationRequiredWrapper/>,
                    children: [
                        {
                            index: true,
                            element: <BusinessesPage/>,
                        },
                        {
                            path: "logout",
                            element: <LogoutPage/>,
                        },
                        {
                            path: "new",
                            element: <NewOrderPage/>,
                            children: [
                                {
                                    path: "",
                                    element: <NewOrderBusinessInfo/>,
                                },
                                {
                                    path: "product",
                                    element: <NewOrderProduct/>,
                                },
                                {
                                    path: "addons",
                                    element: <NewOrderAddons/>,
                                },
                                {
                                    path: "payment",
                                    element: <NewOrderPayment/>,
                                },
                            ],
                        },
                        {
                            path: "users",
                            element: <UsersPage/>,
                            children: [
                                {
                                    path: "",
                                    element: <UsersGrid/>,
                                },
                                {
                                    path: "new",
                                    element: <NewUser/>,
                                },
                            ],
                        },
                        {
                            path: "business/:businessId",
                            element: <BusinessPage/>,
                            children: [
                                {
                                    path: "",
                                    element: <BusinessSummary/>,
                                },
                                {
                                    path: "new",
                                    children: [
                                        {
                                            path: "product",
                                            element: <NewOrderProduct/>,
                                        },
                                        {
                                            path: "addons",
                                            element: <NewOrderAddons/>,
                                        },
                                        {
                                            path: "payment",
                                            element: <NewOrderPayment/>,
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            path: "salesReport",
                            element: <SalesReportPage/>,
                            children: [
                                {
                                    path: "",
                                    element: <GrowthCoachSummary/>,
                                },
                            ],
                        },
                        {
                            path: "accounting",
                            element: <AccountingPage/>,
                            children: [
                                {
                                    path: "",
                                    element: <AccountingTabs/>,
                                },
                            ],
                        },
                        {
                            path: "products",
                            element: <ProductsPage/>,
                            children: [
                                {
                                    path: "",
                                    element: <InventoryManagement/>,
                                },
                            ],
                        },
                        {
                            path: "audiences",
                            element: <AudiencesPage/>,
                        }
                    ],
                },
                {
                    path: "signDocument/:eSignToken",
                    element: <RemotePurchase/>,
                },
            ],
        },
    ]);

    return <RouterProvider router={router}/>;
};
